import { autoinject } from 'aurelia-dependency-injection';

export class LocalhostHandlerConfig {
  defaultTenantSubdomain: string;
  constructor() {
    throw new Error('should have been injected in IOC');
  }
}

@autoinject
export class LocalhostHandler {
  constructor(private config: LocalhostHandlerConfig) {}
  async checkForLocalhost() {
    const { defaultTenantSubdomain } = this.config;
    const { protocol, host, hostname } = new URL(window.location.href);

    if (hostname !== 'localhost' || !Boolean(defaultTenantSubdomain)) {
      return;
    }

    console.log('Dev environment (localhost) detected.  Redirecting to default subdomain.');
    window.location.replace(`${protocol}//${defaultTenantSubdomain}.${host}`);

    // stop app here, don't resolve the promise
    return new Promise(resolve => { });
  }
}



// WEBPACK FOOTER //
// ./src/portal-react-app/LocalhostHandler.ts